// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface MoodleCycle {
  key: string;
  label: string;
  average: boolean; // colonne « Moy. » (avancement global du cycle)
}

export interface MoodleActivity {
  key: string;
  label: string;
  title: string;
  cycle: string;
  module: string; // type de module Moodle : lien /mod/<module>/view.php?id=<cmid>
  cmid: number;
  optional?: boolean;
}

export interface MoodleAverage {
  average: number;
  done: number;
  counted: number;
}

export interface MoodleView {
  count: number;
  first: string;
  last: string;
}

export interface MoodleStudentStats {
  id: number;
  lastname: string | null;
  firstname: string | null;
  td_group: string | null;
  in_moodle: boolean;
  last_seen_at: string | null;
  active_days_7: number;
  active_days_30: number;
  weekly_active_days: number[];
  grades: Record<string, number | null>;
  averages: Record<string, MoodleAverage>; // par cycle (seulement ceux qui ont une moyenne)
  views: Record<string, MoodleView>;
}

export interface MoodleStatsReport {
  collected_at: string | null;
  weeks: string[];
  cycles: MoodleCycle[];
  activities: MoodleActivity[];
  resources: MoodleActivity[];
  students: MoodleStudentStats[];
}

// Suivi Moodle (enseignant·es) : statistiques collectées toutes les 12 h par le worker moodle-sync
class MoodleStatsService {

  async getReport(accessToken: string): Promise<MoodleStatsReport> {
    const response = await fetch(`${API_BASE_URL}/moodle-stats`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    const json = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }

    return json.data;
  }
}

export const moodleStatsService = new MoodleStatsService();
